import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/movementV2/pageContext';

export function MovementV2ErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for MovementV2 page (error: ${error})`);
}
